export const Prices = [
  {
    _id: 0,
    name: "₹ 0 to 50",
    array: [0, 50],
  },
  {
    _id: 1,
    name: "₹ 50 to 100",
    array: [50, 100],
  },
  {
    _id: 2,
    name: "₹ 100 to 150",
    array: [100, 150],
  },
  {
    _id: 3,
    name: "₹ 150 to 300",
    array: [150, 300],
  },
  {
    _id: 4,
    name: "₹ 300 to 500",
    array: [300, 500],
  },
  {
    _id: 4,
    name: "₹ 500 or more",
    array: [500, 9999],
  },
];
